import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "m16.64 18.778 4.815-10.849s.838-1.528-.316-2.681c-1.153-1.154-3.115-.572-3.115-.572L3.947 6.879s-1.467.086-1.662.755c-.194.67.432 1.165.432 1.165l5.976 2.891L18.5 7l-8.815 5.747 5.25 6.233s.503.573 1.01.45c.506-.125.695-.652.695-.652Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M7.974 17.153V12.31l3.64 4.08-2.979 1.16s-.196.13-.417 0c-.22-.13-.244-.397-.244-.397Z"
    }
  )
);
var SvgSendFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var SendFilled_default = SvgSendFilled;

export { SendFilled_default as default };
